import axios from "axios"
import qs from 'qs'
import log from './log'
import constData from './const'
import i18n from './i18n'
import util from "utils/util";
import {Notify} from 'vant'
import {
    loadToken,
} from '@/utils/cache'

function handleErrorCode(code, data, reqConfig) {
    // code 状态码
    let sucCodes = [200, 10005, 10006, 10007, 10008, 10009, 10010, 10011, 10012, 10013]//包含了 支付状态结果的码
    if (sucCodes.indexOf(code) >= 0) {
        return false
    }
    const state = constData.stateEnum
    if (code === state.NOT_LOGIN_TIMEOUT || code === state.NOT_LOGIN) {
        // 跳转 401 页面
        // store.dispatch("user/clearUserInfo")
        // setToken('')
        // router.push("/")
        return true
    } else if (code === state.NEXT_STEP) {
        if (reqConfig.handleNextStep) {
            reqConfig.handleNextStep(data)
        }
        return true
    } else {
        if (reqConfig.onFailCancel) {
            let content = reqConfig.errObj ? reqConfig.errObj : {content: `${data.message}`}
            let onFailOK = reqConfig.onFailOk ? reqConfig.onFailOk : null
            let onFailCancel = reqConfig.onFailCancel
            // myUtil.showConfirm(content, onFailOK, onFailCancel);
        } else {
            let content = reqConfig.errObj ? reqConfig.errObj : {content: `${data.message}`}
            let onFail = reqConfig.onFailOk ? reqConfig.onFailOk : null
            // myUtil.showAlert(content, onFail)
        }
        return true
    }

}

function handleSuccessCode(code, data, reqConfig) {
    let createMessage = function (msg) {
        Notify({
            message: `${msg}`,
            type: 'success',
            duration: 2 * 1000
        });
    }
    if (reqConfig.apiType !== 'check') {
        // 如果用户想看到成功的message提示，则要手动设置，默认是不显示；若要显示，且要同时设置 提示信息，否则提示信息为空，肯定不能被显示
        if (reqConfig.needSuccessMsg && reqConfig.successMsg) {
            createMessage(reqConfig.successMsg);
        }
        if (typeof data.message === 'object') {
            createMessage('操作成功。');
            // 如果返回的 是 字符串，则原文提示
        } else if (typeof data.message === 'string') {
            createMessage(data.message);
        }
    }
}

function handleError(error) {
    if (error) {
        error.message = `error ${error.state} ${error.cause}`
    } else {
        error.state = 500
        error.message = i18n.t('error.network')
    }
    Notify({
        type: 'danger',
        message: error.message || i18n.t('error.network')
    })
    return Promise.reject(error)
}

const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 8000,
    headers: {
        "Content-Type": "application/json;charset=UTF-8",
    },
    transformRequest: [
        function (data) {
            return data ? JSON.stringify(data) : JSON.stringify({})
        },
    ],
    withCredentials: true,
})

service.interceptors.request.use(
    config => {
        if (config.method === 'post') {
            // 为兼容7.0本有的逻辑，当请求没有设置 dataType 时，都默认是 json 格式处理
            if (!config.hasOwnProperty('dataType') || config.dataType === 'json') { // json 格式 后台对应@RequestBody
                config.headers['Content-Type'] = 'application/json'
            } else if (config.dataType === 'file') {
                // 附件处理
                config.headers['Content-Type'] = 'multipart/form-data'
            } else {
                // 后台对应@RequestParam
                config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
                config.data = qs.stringify(config.data)
            }
            config.headers.post['Content-Type'] = config.headers['Content-Type']
            config.headers["token"] = loadToken()
            config.headers['language'] = util.getLanguage().toUpperCase()
        }
        return config
    },
    error => {
        log.error('request' + error)
        Promise.reject(error)
    }
)


service.interceptors.response.use(response => {
        const data = response.data
        const reqConfig = response.config
        if (data instanceof Blob) {
            return response
        }
        if (data) {
            const code = data.code || data.state;
            // 处理错误的Code
            let isError = false
            if (reqConfig.ibpsApi) {
                // isError = handleIbpsErrorCode(code, data)
            } else {
                isError = handleErrorCode(code, data, reqConfig)
            }
            if (isError) {
                if(constData.stateEnum.NEXT_STEP === code){
                    return Promise.reject(data)
                }else{
                    const err = new Error(data.message)
                    err.state = code
                    err.cause = data.message
                    return handleError(err)
                }
            }
            // 处理成功Code
            handleSuccessCode(code, data, reqConfig)
        }
        // 返回全部的response
        if (response.config.responseType === 'arraybuffer' || response.config.responseType === 'blob') {
            return response
        }

        if (reqConfig.hasOwnProperty('needResponse')) {
            if (reqConfig.needResponse) {
                return response
            }
        }
        return data
    },
    // 异常处理
    error => {
        if (error && error.response) {
            error.message = i18n.t('error.' + error.response.status, {
                url: error.response.config.url
            })
        } else {
            error.state = 500
            error.message = i18n.t('error.network')
        }
        Notify({
            type: 'danger',
            message: error.message || i18n.t('error.network')
        })
        return Promise.reject(error)
    }
)


export default service
